<div class="tank-correction">
  <div class="reorder">
    <re-reorder-buttons (reorder)="onReorder($event)" />
  </div>

  <div class="delete">
    <re-trash-button (delete)="onDelete()" />
  </div>

  <h2 class="transfer-header text-center">Correction</h2>
  <div class="container">
    <div class="tank">
      <re-tank-summary
        [tank]="from"
        [progress]="fromProgress"
        [progress2]="progress2"
        [tankNumber]="1"
        [tankName]="'HFO (L)'"
        [fuelGrade]="'HFO'"
        [quantity]="from.content!.quantity + correctionAmount"
      />
    </div>

    <div class="correction-amount">
      <input
        (input)="onInputChange()"
        (ngModelChange)="onModelChange()"
        [(ngModel)]="correctionAmount"
        [min]="minAmount"
        [max]="maxAmount"
        type="number"
        name="transfer-amount"
        placeholder="0"
      />
      MT

      <div class="actions">
        <button
          class="rounded-sm bg-indigo-700 px-1"
          (click)="onResetTank()"
        >
          Reset
        </button>
        <br />
        <button
          class="rounded-sm bg-indigo-700 px-1"
          (click)="onEmptyTank()"
        >
          Empty Tank
        </button>
        <br />
        <button
          class="rounded-sm bg-indigo-700 px-1"
          (click)="onFillTank()"
        >
          Fill Tank
        </button>
      </div>
    </div>
  </div>
</div>
